import React from 'react';
import "./Header.css";
import {IconButton, Avatar} from '@material-ui/core';
import HomeIcon from "@material-ui/icons/Home";
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import SendIcon from '@material-ui/icons/Send';
import ExploreIcon from '@material-ui/icons/Explore';
function Header() {
    return (
        <div className="header">

            <div className="insta">
                <img src="insta.png" alt="Insta"/>
            </div>

             <div className="search">
            <input 
            type="text"
             placeholder= " Search"
             />
                </div>

                <div className="rightSide" >
                
                <div className="pictures rightSide">
                <HomeIcon fontSize="large"/>
            </div>
                    

                    <div className="pictures rightSide">
                    <SendIcon fontSize="large"/>
                    
                    </div>

                    <div className="pictures rightSide">
                    <ExploreIcon fontSize="large"/>
                    
                    </div>

                    <div className="pictures rightSide">
                    
                    <FavoriteBorderIcon fontSize="large"/>
                    
                    </div>

                    <div className="profile_info rightSide">
                    <Avatar src="" fontSize="large"/>
                    </div>
                    </div>
                
        </div>
    )
}

export default Header
